import { render } from "./dispatch-waiting.vue?vue&type=template&id=1dd31580&scoped=true"
import script from "./dispatch-waiting.vue?vue&type=script&lang=js"
export * from "./dispatch-waiting.vue?vue&type=script&lang=js"

import "./dispatch-waiting.vue?vue&type=style&index=0&id=1dd31580&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd31580"]])

export default __exports__